<div class="modal-header">
	<h2 i18n="@@online_payment_modal.title">Online Payment Information </h2>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
		<svg version="1.1" x="0px" y="0px" width="14" height="14"  viewBox="0 0 14 14">
			<path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"/>
		</svg>
	</button>
</div>
<form [formGroup]="paymentForm" (ngSubmit)="submit()">
	<div class="modal-body">
		<div class="online-payment-row">
			<ng-container i18n="@@invoices.insert_amount_to_be_paid_now">Insert amount to be paid now</ng-container>
			<fieldset [ngClass]="{'has-error': submitted && paymentForm.get('amount').errors}">
				<input type="number" formControlName="amount" placeholder="0" />

				<div class="text-danger" *ngIf="submitted && paymentForm.get('amount').errors?.required" i18n="@@error.required">Required</div>
				<div class="text-danger" *ngIf="paymentForm.get('amount').errors?.max" i18n="@@error.max_amount"> Amount must be less than {{ paymentForm.get('amount').errors?.max.max | myCurrency }} </div>

				<div class="text-danger" *ngIf="paymentForm.get('amount').errors?.min" i18n="@@error.min_amount"> Amount must be greater than {{ 0 | myCurrency }} </div>
			</fieldset>
		</div>
		<div class="online-payment-row">
			<ng-container i18n="@@invoices.client_will_receive_payment_link_for">Your client will receive an online payment link for</ng-container>
			<span class="price">{{ paymentForm.get('amount').value ? (paymentForm.get('amount').value | myCurrency ) : 0.00 | myCurrency }}</span>
		</div>
	</div>
	
	<div class="modal-footer">
		<button type="submit" [disabled]="!paymentForm.valid" class="tu-btn pink" i18n="@@online_payment_modal.save_and_email">Save and Send Email</button>
	</div>
</form>